import { V as m } from "../../index.esm-YJBIRYbu.js";
import { RequestError as n } from "./classes/RequestError.js";
import { UnknownError as c } from "./classes/UnknownError.js";
import { ValidationError as f } from "./classes/ValidationError.js";
const a = (r) => {
  throw r instanceof m ? new f(r.message) : r instanceof n ? new n(r.message) : new c(r.message);
}, g = (r, l, o) => {
  const e = o.value;
  return o.value = function(...i) {
    try {
      const t = e.apply(this, i);
      return t && t instanceof Promise ? t.catch((s) => {
        a(s);
      }) : t;
    } catch (t) {
      a(t);
    }
  }, o;
};
export {
  g as Catch
};
